import Spinner from "../../components/Spinner";
import React, {useEffect, useState} from "react";
import axiosInstance from "../../api";
import LeadContactInfo from "./LeadContactInfo";
import LeadStatusUpdate from "./LeadStatusUpdate";
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Box,
    Button,
    Grid,
    Link,
    Snackbar,
    Typography
} from "@material-ui/core";
import {ExpandMore, KeyboardArrowLeft, KeyboardArrowRight} from "@mui/icons-material";
import PropertyAddressViewTile from "./PropertyAddressViewTile";
import PropertyRequirementViewTile from "./PropertyRequirementViewTile";
import PropertyDetailsViewTile from "./PropertyDetailsViewTile";
import OtherDetailsViewTile from "./OtherDetailsViewTile";
import PetsViewTile from "./PetsViewTile";
import {Stack} from "@mui/material";
import {MUIConfirmationDialog} from "../../utils/formUtils";
import {Alert} from "@material-ui/lab";
import {useUserContext} from "../../context/UserContext";

const initDialogProp = {title:null, content:null, show:false, action:null, additionalAttributes:null};
export default function LeadStatusUpdatePage({agentId, leadAgentId, setShowLeadUpdatePage, quoteStatus, onReturnBack}) {

    const {user,dispatch} = useUserContext();
    const [showSpinner, setShowSpinner] = useState(false);
    const [ldata, setLeadUpdateData] = useState({leadAddress: {}, leadContact: {}, leadRequest: {}});
    const [quoteStatusValue, setQuoteStatusValue] = useState(quoteStatus);
    const [quoteStatusEditable, setQuoteStateEditable] = useState(false);
    const [dialogProperties, setDialogueAttributes] = useState(Object.assign({},initDialogProp));
    const [snackBarSettings, setSnackBarSettings] = useState({show:false, message : 'An error occured. Please try later', variant:''});

    useEffect(() => {
        getLeadUpdatedInformation();
    }, [leadAgentId])

    const getLeadUpdatedInformation = () => {
        setShowSpinner(true)
        axiosInstance.get(`unauth/leads/getAgentLeadUpdateInformation/${leadAgentId}`).then(data => {
            setLeadUpdateData(Object.assign({}, data))
            if (data && data.quoteStatus) {
                setQuoteStatusValue(data.quoteStatus);
            }
            if(data && data.quoteStatusEditable != null){
                setQuoteStateEditable(data.quoteStatusEditable);
            }
            setShowSpinner(false)
        }).catch(() => setSnackBarSettings({show:true, message : 'An error occured. Please try later', variant:'error'})).finally(() => setShowSpinner(false))
    }

    const handleRecordTagging = (leadAgentId, leadAddress) => {
        setDialogueAttributes({title:'Tag Lead', content:'Are you sure you would like to offer coverage to this consumer? If you select OK, you are required to provide the status on the lead by the status update deadline in FMAP system.', show:true, action:'TAGGED', additionalAttributes: {leadAgentId}});
    }


    const handleBooleans = (val) => {
        return (!!val) ? "YES" : "NO";
    }
    function handleDClose() {
        setDialogueAttributes(Object.assign({},initDialogProp));
    }

    function handleDConfirm() {
        updateLeadStatus(dialogProperties?.additionalAttributes?.leadAgentId, dialogProperties.action, 'Lead has been tagged successfully!', 'An error occurred while tagging a lead. Please try again later.');
        setDialogueAttributes(Object.assign({},initDialogProp));
    }

    const updateLeadStatus = (leadAgentId, status, successMsg, errorMsg) => {
        setShowSpinner(true);
        let leadAgentMapDTOS = [];
        leadAgentMapDTOS.push({leadAgentMapId: leadAgentId, leadId:ldata?.leadId, quoteStatus: 'TAGGED', agentId: ldata?.agentId});
        axiosInstance.post('lead-agent/update-lead-agent-map-status/'+status, leadAgentMapDTOS)
            .then((data) => {
                if (data === -100) {
                    setSnackBarSettings(Object.assign({}, {show: true, message: 'You currently have 25 tagged leads that require a status update, therefore, you are unable to tag any new leads at this time.', variant: 'error'}));
                } else {
                    setSnackBarSettings(Object.assign({}, {show: true, message: successMsg, variant: 'success'}));
                    setQuoteStatusValue('TAGGED');
                }
            })
            .catch((error) => {
                setSnackBarSettings(Object.assign({},{show:true, message : errorMsg, variant:'error'}));
            })
            .finally(() => setShowSpinner(false))
    }

    const handleSnackBarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setSnackBarSettings(Object.assign({},{show:false, message : 'An error occured. Please try later', variant:''}));
    }


    if (showSpinner) return <Spinner/>
    return <>
        <Grid container xs={12} sm={12} md={12} alignItems="flex-start" spacing={2}>
            <Grid item xs={6} sm={6} md={6}>
                <Box component="span" justifyContent="flex-start" marginLeft="16px" marginTop="8px"
                     alignItems="flex-end" display="flex">
                    {quoteStatus === 'NOT_TAGGED' && <Link onClick={() => onReturnBack()}>Back to Matched Leads</Link>}
                    {quoteStatus === 'TAGGED' && <Link onClick={() => onReturnBack()}>Back to Tagged Leads</Link>}
                    {(quoteStatus === 'TR_ST_OFFACC'
                        || quoteStatus === 'TR_ST_OFFNOACC'
                        || quoteStatus === 'TR_ST_OFFNOACCM') && <Link onClick={() => onReturnBack()}>Back to Resolved Leads</Link>}
                </Box>
            </Grid>
            <Grid item xs={6} sm={6} md={6}>
                {quoteStatusValue === 'NOT_TAGGED' && <Box component="span" justifyContent="flex-end" marginTop="8px" marginRight="8px" alignItems="flex-end" display="flex">
                {user.locked === "N" && (user.fmapRole === "FMAP_ADMIN" || user.fmapRole === "FMAP_AGENT") && <Link onClick={() => handleRecordTagging(leadAgentId)}>Tag Record</Link>}
                </Box>}
            </Grid>
        </Grid>


        <div>
            {quoteStatusValue === 'TAGGED' &&
                <>
                    <Accordion expanded>
                        <AccordionSummary
                            expandIcon={<ExpandMore/>}
                            aria-controls="updLeadStatus"
                            id="updLeadStatus"
                        >
                            <Typography variant="h5">Update Lead Status</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <LeadStatusUpdate leadAgentId={leadAgentId} leadAgentData={ldata}
                                              getLeadUpdatedInformation={getLeadUpdatedInformation} agentId={agentId}  user={user}/>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion>
                        <AccordionSummary
                            expandIcon={<ExpandMore/>}
                            aria-controls="leadContactInfo"
                            id="leadContactInfo"
                        >
                            <Typography variant="h5">Lead Contact Info</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <LeadContactInfo leadInformation={ldata}/>
                        </AccordionDetails>
                    </Accordion>

                    <Accordion>
                        <AccordionSummary
                            expandIcon={<ExpandMore/>}
                            aria-controls="propChars"
                            id="propChars"
                        >
                            <Typography variant="h5">Property Characteristics</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            {/*<LeadPropertyDetailsView propertyCharacteristics={ldata.leadRequest}/>*/}
                            <Stack>
                                <PropertyAddressViewTile consumerData={ldata.leadRequest}/>
                                <PropertyRequirementViewTile consumerData={ldata.leadRequest}/> <br/>
                                <PropertyDetailsViewTile consumerData={ldata.leadRequest}/><br/>
                                <OtherDetailsViewTile consumerData={ldata.leadRequest} handleBooleans={handleBooleans}/><br/>
                                <PetsViewTile consumerData={ldata.leadRequest} handleBooleans={handleBooleans}/><br/>
                            </Stack>
                        </AccordionDetails>
                    </Accordion>
                </>}
            {quoteStatusValue !== 'TAGGED' &&
            <>
                <Box m={3}>
                    <Stack>
                        { quoteStatusEditable &&
                            (user.fmapRole === 'FMAP_AGENT' || user.fmapRole === 'FMAP_ADMIN')  &&
                            ((quoteStatusValue === 'TR_ST_OFFNOACC') ||
                                (quoteStatusValue === 'TR_ST_OFFACC') ||
                                (quoteStatusValue === 'TR_ST_OFFNOACCM')) &&
                            ((ldata?.leadRequest?.coverageStartDate - new Date().getTime())/(1000*3600*24) >= -30) &&
                        <>
                            <Typography variant="h5">Update Lead Status</Typography><br/>
                            <LeadStatusUpdate leadAgentId={leadAgentId} leadAgentData={ldata}
                                              getLeadUpdatedInformation={getLeadUpdatedInformation} agentId={agentId} user={user}/>
                        </>
                        }

                        <PropertyAddressViewTile consumerData={ldata.leadRequest}/><br/>
                        <PropertyRequirementViewTile consumerData={ldata.leadRequest}/> <br/>
                        <PropertyDetailsViewTile consumerData={ldata.leadRequest}/><br/>
                        <OtherDetailsViewTile consumerData={ldata.leadRequest} handleBooleans={handleBooleans}/><br/>
                        <PetsViewTile consumerData={ldata.leadRequest} handleBooleans={handleBooleans}/><br/>
                    </Stack>
                </Box>
            </>}
        </div>
        <br/>
        <br/>
        <MUIConfirmationDialog dialogTitle={dialogProperties.title}
                               dialogContent={dialogProperties.content}
                               showDialog={dialogProperties.show} handleDialogClose={handleDClose}
                               handleUserConfirmation={handleDConfirm}></MUIConfirmationDialog>

        <Snackbar open={snackBarSettings.show} autoHideDuration={6000} onClose={handleSnackBarClose}>
            <Alert variant="filled" onClose={handleSnackBarClose}
                   severity={snackBarSettings.variant}>{snackBarSettings.message}</Alert>
        </Snackbar>

        {/* {ldata && ldata.leadUpdateList &&
            ldata.leadUpdateList.map( item => <CommentCompactView key={item.id} data={item}/> )
        }*/}
    </>
}
